module.exports = __webpack_public_path__ + "static/img/back-color.98198beb.svg";